import { useActivePageId, usePage, useUpdatePage } from "../../../data";
import { potentiallyInvisibleColumns } from "../columns";
import type { GetContextMenuSection } from "./helpers";
import { getIcon } from "./icons";
import { useUserSubscriptionTier } from "../../../data/user";

export const useGetMenuItemsCurveDetails = (): GetContextMenuSection => {
  const { disabledFeatures } = useUserSubscriptionTier();
  const pageId = useActivePageId();
  const page = usePage(pageId);
  const updatePage = useUpdatePage();

  return (ctx) => {
    if (!ctx.isProduct || !ctx.isHeaderMenuItem) return [];
    return [
      {
        disabled: disabledFeatures?.curveDetails,
        name: "Curve Details",
        tooltip: disabledFeatures?.curveDetails ? "Please upgrade your subscription to access this feature" : undefined,
        icon: getIcon("details"),
        subMenu: potentiallyInvisibleColumns.map(({ name, label, defaultVisible }) => {
          const pageValue = page.data?.[name as keyof typeof page.data];
          const selected = typeof pageValue === "boolean" ? pageValue : defaultVisible;
          return {
            name: label,
            icon: selected ? getIcon("check") : "",
            action: () => updatePage.optimistic({ id: pageId, [name]: !selected }),
          };
        }),
      },
    ];
  };
};
